define('BookingEngine/app-formElementsBE/main',[], function () {
    return {
        run: function () {
            $(".radioStyled input[type='radio'], .radioStyled:hidden input[type='radio'], .checkboxStyled input[type='checkbox'], .checkboxStyled:hidden input[type='checkbox']").each(function () {
                var $this = $(this);

                if ($this.is(":checked")) {
                    $this.parent("label").addClass("checked");
                }
            });

            $(document).on("change", ".checkboxStyled input[type='checkbox']", function () {
                var $this = $(this);

                if ($this.is(":checked")) {
                    $this.closest("label").addClass("checked");
                } else {
                    $this.closest("label").removeClass("checked");
                }
            });

            $(document).on("change", ".radioStyled input[type='radio']", function (e) {
                var $this = $(this);
                var $radioStyled = $this.closest(".radioStyled");

                if ($radioStyled.hasClass("disabled")) {
                    e.preventDefault();

                    return false;
                }

                $radioStyled.find("label").removeClass("checked");

                if ($this.is(":checked")) {
                    $this.parent("label").addClass("checked");
                }
            });

            window.loadedModules("BookingEngine/app-formElementsBE");
        }
    }
});
